import {
  createContext,
  useContext,
  type ReactNode,
} from "react";

export type CallChromeValue = {
  headerVisible: boolean;
  callTypeLabel: string;
  logoSrc: string | null;
};

const CallChromeContext = createContext<CallChromeValue | null>(null);

export function CallChromeProvider({
  value,
  children,
}: {
  value: CallChromeValue;
  children: ReactNode;
}) {
  return (
    <CallChromeContext.Provider value={value}>
      {children}
    </CallChromeContext.Provider>
  );
}

export function useCallChrome() {
  const ctx = useContext(CallChromeContext);
  if (!ctx) {
    throw new Error("useCallChrome must be used within CallChromeProvider");
  }
  return ctx;
}
